/* ============================================================================
   BKS — DECLENCHEMENT DE LA PAGE PRE-PAIEMENT
   ----------------------------------------------------------------------------
   Au clic sur "Passer la commande" (page panier ET tiroir panier), si le panier
   contient une selle (tag "bks-selle") et que l'offre n'a pas encore ete vue
   dans la session, on detourne vers /pages/complete-ta-commande.

   POURQUOI UN ECOUTEUR SUR window ET PAS SUR document
   ---------------------------------------------------
   bks-cart-guard.js ecoute deja le clic sur `document` en phase de CAPTURE et
   appelle stopImmediatePropagation(). Comme ce fichier est charge APRES lui,
   un ecouteur sur `document` ne serait jamais appele. Or la phase de capture
   descend window -> document -> ... -> cible : un ecouteur sur `window` en
   capture passe donc AVANT celui de cart-guard, quel que soit l'ordre de
   chargement des scripts. C'est le seul point d'accroche qui fonctionne sans
   modifier bks-cart-guard.js.

   LA CHAINE DE VALIDATION N'EST PAS PERDUE : sur la page d'offre, les deux
   sorties sont des <a href="/checkout">, que bks-cart-guard.js intercepte
   normalement. Sa verification des lots de selles a donc toujours lieu, juste
   une etape plus loin dans le tunnel.

   DECISION SYNCHRONE : le clic doit etre traite immediatement (preventDefault
   ne survit pas a un await). On ne fait donc AUCUN appel reseau au moment du
   clic : on lit un drapeau tenu a jour en arriere-plan.
     - au chargement : window.__BKS_CART_SELLE, rendu par Liquid dans theme.liquid
       (verite serveur, tag lu sur le produit) ;
     - apres chaque modification du panier : /cart.js + /products/<handle>.js
       (meme endpoint que bks-kitdeco-assorti.js, qui renvoie les tags).

   FAIL-SAFE ABSOLU : tout est en try/catch et la valeur par defaut est
   "ne rien faire". Drapeau inconnu, sessionStorage indisponible, selecteur
   absent, fetch en echec => on laisse le paiement se derouler normalement.
   Rater une offre est infiniment preferable a bloquer une commande.
   ========================================================================== */
(function () {
  "use strict";

  try {
    if (window.__bksPrePay) { return; }
    window.__bksPrePay = 1;
  } catch (e) { return; }

  var CLE = "bks_prepay_vu";
  var TAG = "bks-selle";
  var HANDLE_PAGE = "complete-ta-commande";

  /* fetch d'origine (deja enveloppe par cart-guard / gift-sync / kitdeco) :
     on s'en sert pour nos propres appels afin de ne pas repasser dans notre hook. */
  var PREV_FETCH = null;
  try { PREV_FETCH = window.fetch; } catch (e) {}

  var A_UNE_SELLE = false;   // decision synchrone du clic
  var CACHE = {};            // handle -> booleen "porte le tag selle"

  function racine() {
    try {
      var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      return String(r).replace(/\/$/, "");
    } catch (e) { return ""; }
  }

  function cible() { return racine() + "/pages/" + HANDLE_PAGE; }

  function dejaVu() {
    /* En cas de sessionStorage indisponible on renvoie "vu" : on n'intercepte
       jamais plutot que de risquer une boucle de redirection. */
    try { return window.sessionStorage.getItem(CLE) === "1"; } catch (e) { return true; }
  }

  function marquer() {
    try { window.sessionStorage.setItem(CLE, "1"); } catch (e) {}
  }

  /* --- Si on est deja sur la page d'offre : on marque et on ne s'accroche a rien. --- */
  try {
    if (window.location.pathname.indexOf(HANDLE_PAGE) !== -1) {
      marquer();
      return;
    }
  } catch (e) { return; }

  /* --------------------- verite serveur au chargement --------------------- */
  try {
    if (window.__BKS_CART_SELLE === true) { A_UNE_SELLE = true; }
  } catch (e) {}

  /* ------------------- rafraichissement en arriere-plan ------------------- */
  function jsonDe(url) {
    if (!PREV_FETCH) { return Promise.reject(new Error("no fetch")); }
    return PREV_FETCH(url, { cache: "no-cache", headers: { Accept: "application/json" } })
      .then(function (r) {
        if (!r || !r.ok) { throw new Error("http"); }
        return r.json();
      });
  }

  function handlePorteSelle(h) {
    if (Object.prototype.hasOwnProperty.call(CACHE, h)) {
      return Promise.resolve(CACHE[h]);
    }
    return jsonDe("/products/" + encodeURIComponent(h) + ".js")
      .then(function (p) {
        var ok = false;
        try {
          var tags = (p && p.tags) || [];
          for (var i = 0; i < tags.length; i++) {
            if (String(tags[i]).trim().toLowerCase() === TAG) { ok = true; break; }
          }
        } catch (e) { ok = false; }
        CACHE[h] = ok;
        return ok;
      })
      .catch(function () { return false; });
  }

  function rafraichir() {
    return jsonDe("/cart.js")
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        if (!items.length) { A_UNE_SELLE = false; return; }
        var uniques = [];
        for (var i = 0; i < items.length; i++) {
          var h = items[i] && items[i].handle;
          if (h && uniques.indexOf(h) === -1) { uniques.push(h); }
        }
        if (!uniques.length) { return; }
        return Promise.all(uniques.map(handlePorteSelle)).then(function (res) {
          var trouve = false;
          for (var j = 0; j < res.length; j++) { if (res[j]) { trouve = true; break; } }
          A_UNE_SELLE = trouve;
        });
      })
      .catch(function () { /* on garde la derniere valeur connue */ });
  }

  /* ------------ on suit les modifications de panier (fetch + XHR) ---------- */
  var RX_PANIER = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;
  var TMR = null;
  function planifier() {
    try {
      if (TMR) { clearTimeout(TMR); }
      TMR = setTimeout(function () { try { rafraichir(); } catch (e) {} }, 350);
    } catch (e) {}
  }

  try {
    if (PREV_FETCH) {
      window.fetch = function () {
        var p = PREV_FETCH.apply(this, arguments);
        try {
          var a = arguments[0];
          var u = (a && a.url) || a || "";
          if (typeof u === "string" && RX_PANIER.test(u) && p && p.then) {
            p.then(function () { planifier(); }).catch(function () {});
          }
        } catch (e) {}
        return p;
      };
    }
  } catch (e) {}

  try {
    var XHR = window.XMLHttpRequest;
    if (XHR && XHR.prototype) {
      var _open = XHR.prototype.open;
      XHR.prototype.open = function (m, u) {
        try { this.__bksPPUrl = u; } catch (e) {}
        return _open.apply(this, arguments);
      };
      var _send = XHR.prototype.send;
      XHR.prototype.send = function () {
        try {
          var self = this;
          if (typeof self.__bksPPUrl === "string" && RX_PANIER.test(self.__bksPPUrl)) {
            self.addEventListener("load", function () { planifier(); });
          }
        } catch (e) {}
        return _send.apply(this, arguments);
      };
    }
  } catch (e) {}

  /* ----------------------------- interception ----------------------------- */

  /* Paiement accelere (Shop Pay, PayPal, Google Pay...) : on ne touche a rien. */
  var SEL_EXPRESS = "shopify-accelerated-checkout, shopify-accelerated-checkout-cart," +
    " .shopify-payment-button, .additional-checkout-buttons," +
    " [class*='dynamic-checkout'], [class*='accelerated-checkout']";

  var SEL_CHECKOUT = "[name='checkout'], a[href$='/checkout'], a[href*='/checkout?']";

  function detourner() {
    marquer();                       // marque AVANT de partir : jamais de boucle
    window.location.href = cible();
  }

  window.addEventListener("click", function (e) {
    try {
      if (!A_UNE_SELLE) { return; }          // pas de selle -> paiement normal
      if (dejaVu()) { return; }              // offre deja proposee cette session
      if (e.defaultPrevented) { return; }
      if (e.button && e.button !== 0) { return; }
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }

      var t = e.target;
      if (!t || !t.closest) { return; }
      if (t.closest(SEL_EXPRESS)) { return; }     // paiement express : on laisse passer
      if (!t.closest(SEL_CHECKOUT)) { return; }

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) { e.stopImmediatePropagation(); }
      detourner();
    } catch (err) {
      /* fail-safe : on ne fait rien, le paiement suit son cours normal */
    }
  }, true);

  window.addEventListener("submit", function (e) {
    try {
      if (!A_UNE_SELLE) { return; }
      if (dejaVu()) { return; }
      if (e.defaultPrevented) { return; }
      var s = e.submitter;
      if (!s || s.name !== "checkout") { return; }
      if (s.closest && s.closest(SEL_EXPRESS)) { return; }

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) { e.stopImmediatePropagation(); }
      detourner();
    } catch (err) {}
  }, true);

  /* ------------------------------- demarrage ------------------------------ */
  function init() {
    try { rafraichir(); } catch (e) {}
  }
  try {
    if (document.readyState !== "loading") { init(); }
    else { document.addEventListener("DOMContentLoaded", init); }
  } catch (e) {}
})();
